/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 21.06.24
 *
 */
import {Type} from "@qwoach/class-transformer-wrapper";
import BaseObject from "@shared/BaseObject.js";
import WorkflowEntryItem from "@shared/Workflow/base/WorkflowEntryItem";
import ClientProfile from "@shared/Profile/ClientProfile";

export default class WorkflowProspectResponse extends BaseObject {

	@Type(() => WorkflowEntryItem)
	entryItem: WorkflowEntryItem = null

	@Type(() => ClientProfile)
	clientProfile: ClientProfile = null

}
